<div class="f-row filled-action-row" *ngIf="OwnerHeading">
  <h6 class="title-subText m-bottom-8x">{{content?.['b2b.register.traveladmintitle']}}</h6>
  <a (keydown.enter)="EditBusinessowner()" tabindex="0" role="button" class="cursor-pointer" *ngIf="EditLinkOwner"
    (click)="EditBusinessowner()">{{content?.['b2b.register.edit']}}</a>
</div>

<form [formGroup]="businessOwnerForm" (ngSubmit)="onSubmit()" autocomplete="off"
  [class.d-none]="!showbusinessOwnerform">
  <div class="f-col">
    <div class="f-col form-info-section">
      <div class="f-row two--ColLayout">
        <div class="f-col">
          <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
            [searchFn]="_CommonService.customCountrySearchFn" formControlName="Nationality"
            [placeholder]="content?.['b2b.register.nationality']" (keypress)="blockInvalidCharacters($event)">
            <ng-template ng-optgroup-tmp let-item="item">
              {{ item.group }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span class="ng-option-label">
                <ng-container *ngIf="!!item?.newFlag?.src">
                  <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                    [height]="item.height" [width]="item.width" />
                </ng-container>
                {{ item.countryName }}
              </span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span class="ng-value-label"> {{ item?.nationality }} </span>
            </ng-template>
            <ng-template ng-notfound-tmp>
              <div class="no-items-found">
                <img src="assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'" class="no-items-image" />
                <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}
              </div>
            </ng-template>
          </ng-select>
          <mat-error class="px-4" *ngIf="
              businessOwnerForm.get('Nationality')?.invalid &&
              businessOwnerForm.get('Nationality')?.touched
            ">
            {{content?.dictionary?.['b2b.register.selectnationality']}}</mat-error>
        </div>
      </div>

      <div class="f-row two--ColLayout">
        <div class="f-col">
          <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
            [searchFn]="_CommonService.customCountrySearchFn" formControlName="countryOfResidence"
            [placeholder]="content?.['b2b.register.countryofresidence']" (keypress)="blockInvalidCharacters($event)">
            <ng-template ng-optgroup-tmp let-item="item">
              {{ item.group }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span class="ng-option-label">
                <ng-container *ngIf="!!item?.newFlag?.src">
                  <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                    [height]="item.height" [width]="item.width" />
                </ng-container>
                {{ item.countryName }}
              </span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span class="ng-value-label"> {{ item?.countryName }} </span>
            </ng-template>
            <ng-template ng-notfound-tmp>
              <div class="no-items-found">
                <img src="assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'" class="no-items-image" />
                <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
              </div>
            </ng-template>
          </ng-select>
          <mat-error class="px-4" *ngIf="
              businessOwnerForm.get('countryOfResidence')?.invalid &&
              businessOwnerForm.get('countryOfResidence')?.touched
            ">{{content?.dictionary?.['b2b.register.selectcor']}}</mat-error>
        </div>
      </div>

      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{ documentLabel }}</mat-label>
            <input matInput formControlName="NationalID" data-dd-privacy="mask" (keypress)="_CommonService.blockSpecialChar($event)"
              (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)"
              (blur)="verifyELM('nn');trimField('NationalID')" (input)="checkFields()" />

            <!-- Error messages -->
            <mat-error *ngIf="businessOwnerForm.get('NationalID')?.hasError('elmError')">
              {{content?.dictionary?.['b2b.register.InvalidIdNumber']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('NationalID')?.hasError('required')">
              {{ documentLabel }} is required.
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('NationalID')?.hasError('pattern')">
              <span *ngIf="CommonObj.docType === 'passportNumber'">
                {{ documentLabel }} must contain only letters and numbers.
              </span>
              <span *ngIf="CommonObj.docType !== 'passportNumber'">
                {{ documentLabel }} must contain only digits.
              </span>
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('NationalID')?.hasError('minlength')">
              {{ documentLabel }} must be at least
              {{ businessOwnerForm.get('NationalID')?.errors?.['minlength']?.requiredLength }}
              <span *ngIf="CommonObj.docType === 'passportNumber'">characters</span>
              <span *ngIf="CommonObj.docType !== 'passportNumber'">digits</span>.
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('NationalID')?.hasError('maxlength')">
              {{ documentLabel }} cannot exceed
              {{ businessOwnerForm.get('NationalID')?.errors?.['maxlength']?.requiredLength }}
              <span *ngIf="CommonObj.docType === 'passportNumber'">characters</span>
              <span *ngIf="CommonObj.docType !== 'passportNumber'">digits</span>.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="f-col hideCalendar c-position-right position-relative">
          <mat-form-field (click)="showComponent('isDOBCalendarVisible', 'DOB')">
            <mat-label>{{onBoardContent?.['b2b.managetraveler.dateofbirth']}}</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix (click)="showComponent('isDOBCalendarVisible', 'DOB'); $event.stopPropagation()" style="cursor: pointer;">calendar_today</mat-icon>
            <input matInput formControlName="DOB" data-dd-privacy="mask" (keypress)="blockInvalidCharactersForDOB($event)"
              (blur)="verifyELM('nn'); isDOBInvalid()" (paste)="onPasteBlocked($event)"
              (contextmenu)="disableRightClick($event)" readonly />
            <mat-error *ngIf="businessOwnerForm.get('DOB')?.hasError('required')">
              {{content?.dictionary?.['passenger.errordateofbirth']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('DOB')?.hasError('maxlength')">
              {{content?.dictionary?.['b2b.register.cannotexceeddob']}}
            </mat-error>
            <mat-error *ngIf="
                businessOwnerForm.get('DOB')?.hasError('noHtmlTagsValidator')
              ">
              {{content?.dictionary?.['b2b.register.validdob']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('DOB')?.hasError('minlength')">
              {{content?.dictionary?.['b2b.register.dob2char']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('DOB')?.hasError('invalidAdultDOB')">
              {{content?.dictionary?.['b2b.register.agerequirement']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('DOB')?.hasError('invalidFormat')">
              {{content?.dictionary?.['b2b.register.dobdateformat']}}
            </mat-error>
          </mat-form-field>
          <app-date-of-birth-calendar *ngIf="isChildVisible['isDOBCalendarVisible']"
            (dateSelected)="onDateSelected($event)"
            (confirm)="onConfirm('isDOBCalendarVisible')"></app-date-of-birth-calendar>
        </div>
      </div>


      <div class="f-col position-relative open-calendar-bottom">
        <mat-form-field appearance="fill"
          (click)="showComponent('isExpiaryCalendarVisible','docExpiry'); $event.stopPropagation()"
          (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (keypress)="_CommonService.blockInvalidCharacters1($event)">
          <mat-label>{{this.CommonObj.docName + ' '}} {{onBoardContent?.['b2b.managetraveler.expirydate']}}</mat-label>
          <input matInput [placeholder]="content?.dictionary?.['b2b.register.selectdocexpirydate'] || 'Select doc Expiry date'" formControlName="docExpiry" data-dd-privacy="mask"
            [value]="selectedExpiryDate ? (selectedExpiryDate | date: 'dd/MM/y') : ''" readonly />
          <mat-icon fontSet="material-symbols-outlined" matSuffix (click)="showComponent('isExpiaryCalendarVisible','docExpiry'); $event.stopPropagation()" style="cursor: pointer;">calendar_today</mat-icon>
          <mat-error
            *ngIf="businessOwnerForm.get('docExpiry')?.hasError('required') && businessOwnerForm.get('docExpiry')?.touched">
            {{this.CommonObj.docName}} expiry date is required. </mat-error>
        </mat-form-field>
        <app-expiry-date *ngIf="isChildVisible['isExpiaryCalendarVisible']" [passengerTravelerCode]="'ADT'"
          (dateSelected)="onDateSelected2($event,'isExpiaryCalendarVisible')"
          (confirm)="onConfirm('isExpiaryCalendarVisible')"
          [filledDate]="selectedExpiryDate ? (selectedExpiryDate | date: 'dd/MM/y') : ''"
          [maxYearLimit]="docExpiryMaxYears"
          [useCurrentDateAsMin]="true">
        </app-expiry-date>
      </div>


      <div class="f-row two--ColLayout passenger-title-input">
        <div class="f-col control-wrapper">
          <mat-form-field>
            <mat-label>{{content?.['b2b.register.title']}}</mat-label>
            <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select" [ngStyle]="{
                color: businessOwnerForm.get('title')?.value
                  ? 'green'
                  : 'rgba(0, 0, 0, 0.55)'
              }">
              stat_minus_1
            </mat-icon>
            <mat-select formControlName="title" (keypress)="blockInvalidCharacters($event)">
              <mat-option *ngFor="let option of filteredTitles; let i = index"
                [value]="option.Phrase" [ngClass]="{
                  'mat-option-country-code-machted':
                    i === 0 && !businessOwnerForm.get('title')?.value,
                  'mat-option-selected':
                    businessOwnerForm.get('title')?.value === option.Phrase
                }">
                {{ option.Phrase }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="
                businessOwnerForm.get('title')?.hasError('required') &&
                businessOwnerForm.get('title')?.touched
              ">
              {{content?.dictionary?.['b2b.register.selecttitle']}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="f-col control-wrapper">
          <mat-form-field>
            <mat-label>{{content?.['b2b.register.firstname']}}</mat-label>
            <input matInput formControlName="firstName" data-dd-privacy="mask" (keypress)="blockNumbers($event)"
              (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)"
              (blur)="trimField('firstName')" />
            <mat-error *ngIf="businessOwnerForm.get('firstName')?.hasError('required')">
              {{content?.dictionary?.['b2b.register.enterfirstname']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('firstName')?.hasError('maxlength')">
              {{content?.dictionary?.['b2b.register.cannotexceedfirstname']}}
            </mat-error>
            <mat-error *ngIf="
                businessOwnerForm
                  .get('firstName')
                  ?.hasError('noHtmlTagsValidator')
              ">
              {{content?.dictionary?.['b2b.register.entervalidinput']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('firstName')?.hasError('minlength')">
              {{content?.dictionary?.['b2b.register.firstname2char']}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.register.lastname']}}</mat-label>
            <input matInput formControlName="lastName" data-dd-privacy="mask" (keypress)="blockNumbers($event)"
              (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)"
              (blur)="trimField('lastName')" />
            <mat-error *ngIf="businessOwnerForm.get('lastName')?.hasError('required')">
              {{content?.dictionary?.['b2b.register.enterlastname']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('lastName')?.hasError('maxlength')">
              {{content?.dictionary?.['b2b.register.cannotexceedlastname']}}
            </mat-error>
            <mat-error *ngIf="
                businessOwnerForm
                  .get('lastName')
                  ?.hasError('noHtmlTagsValidator')
              ">
              {{content?.dictionary?.['b2b.register.entervalidinput']}}.
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('lastName')?.hasError('minlength')">
              {{content?.dictionary?.['b2b.register.lastname2char']}}.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col">
          <div class="f-row validation-col radio-group-container">
            <label class="mat-label" for="Gender">{{content?.['b2b.register.gender']}}</label>
            <mat-radio-group id="gender" formControlName="gender" aria-label="Select a gender">
              <mat-radio-button value="Male">{{content?.['b2b.register.male']}}</mat-radio-button>
              <mat-radio-button value="Female">{{content?.['b2b.register.female']}}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.register.employeecode ']}}</mat-label>
            <input matInput formControlName="EmpCode" data-dd-privacy="mask" (keypress)="_CommonService.blockSpecialChar($event)"
              (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)"
              (blur)="trimField('EmpCode')" />
            <mat-error *ngIf="businessOwnerForm.get('EmpCode')?.hasError('required')">
              {{content?.dictionary?.['b2b.register.employeecodereq']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('EmpCode')?.hasError('pattern')">
              {{content?.dictionary?.['b2b.register.validempcode']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('EmpCode')?.hasError('minlength')">
              {{content?.dictionary?.['b2b.register.employeecode4char']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('EmpCode')?.hasError('maxlength')">
              {{content?.dictionary?.['b2b.register.cannotexceedempcode']}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="f-col">
        <mat-form-field>
          <mat-label>{{content?.['b2b.register.designation']}}</mat-label>
          <input matInput formControlName="jobTitle" data-dd-privacy="mask" (paste)="onPasteBlocked($event)"
            (keypress)="blockSpecialCharAndNumbers($event)" (contextmenu)="disableRightClick($event)"
            (blur)="trimField('jobTitle')" />
          <mat-error *ngIf="businessOwnerForm.get('jobTitle')?.hasError('required')">
            {{content?.dictionary?.['b2b.register.enterdesignation']}}
          </mat-error>
          <mat-error *ngIf="businessOwnerForm.get('jobTitle')?.hasError('maxlength')">
            {{content?.dictionary?.['b2b.register.cannotexceeddesignation']}}
          </mat-error>
          <mat-error *ngIf="
                businessOwnerForm
                  .get('jobTitle')
                  ?.hasError('noHtmlTagsValidator')
              ">
            {{content?.dictionary?.['b2b.register.entervalidinput']}}.
          </mat-error>
          <mat-error *ngIf="businessOwnerForm.get('jobTitle')?.hasError('minlength')">
            {{content?.dictionary?.['b2b.register.designation2Char']}}</mat-error>
        </mat-form-field>
      </div>

      <div class="f-row">
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.register.businessemail']}}</mat-label>

            <input matInput formControlName="email" data-dd-privacy="mask" (blur)="onEmailBlur()" (keypress)="blockInvalidCharacters($event)"
              (keypress)="Onlyrs($event)" (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)"
              (blur)="trimField('email')" />
            <mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>
            <mat-error *ngIf="businessOwnerForm.get('email')?.hasError('required')">
              {{content?.dictionary?.['b2b.booking.enteremailaddress']}}
            </mat-error>
            <mat-error *ngIf="
                businessOwnerForm.get('email')?.hasError('customEmailValidator')
              ">
              {{content?.dictionary?.['b2b.booking.entervalidemailaddress']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('email')?.hasError('email')">
              {{content?.dictionary?.['b2b.booking.entervalidemailaddress']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('email')?.hasError('maxlength')">
              {{content?.dictionary?.['b2b.register.cannotexceedemail']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('email')?.hasError('emailExists')">
              {{content?.dictionary?.['b2b.managecompany.emailalreadyexists']}}
            </mat-error>
            <mat-error *ngIf="
                businessOwnerForm.get('email')?.hasError('forbiddenCharacters')
              ">
              {{content?.dictionary?.['b2b.register.entervalidinput']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('email')?.hasError('invalidEmail')">
              {{content?.dictionary?.['b2b.register.entervalidinput']}}
            </mat-error>
            <mat-error *ngIf="
                businessOwnerForm.get('email')?.hasError('domainMismatch') &&
                businessOwnerForm.get('email')?.touched
              ">
              {{content?.dictionary?.['b2b.register.companydomainemail']}} (e.g. user&#64;{{
              corporateInfo?.domainName
              }})
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="f-row">
        <div class="f-col" [formGroup]="stateForm">
          <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
            [searchFn]="_CommonService.customCountrySearchFn" formControlName="stateGroup"
            [placeholder]="content?.['b2b.register.countrycode']"
            (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
            (keypress)="_CommonService.blockInvalidCharacters($event)">
            <ng-template ng-optgroup-tmp let-item="item">
              {{ item.group }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span class="ng-option-label">
                <ng-container *ngIf="!!item?.newFlag?.src">
                  <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                    [height]="item.height" [width]="item.width" />
                </ng-container>
                {{ item.code }} ({{ item?.countryName }})
              </span>
            </ng-template>
            <ng-template ng-label-tmp let-item="item">
              <span class="ng-value-label"> {{ item.code }} </span>
            </ng-template>
            <ng-template ng-notfound-tmp>
              <div class="no-items-found">
                <img src="assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'" class="no-items-image" />
                <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
              </div>
            </ng-template>
          </ng-select>
          <mat-error class="px-4" *ngIf="
              stateForm.get('stateGroup')?.hasError('required') &&
              stateForm.get('stateGroup')?.touched
            ">
            {{content?.dictionary?.['b2b.register.selectcountrycode']}}
          </mat-error>
        </div>
      </div>

      <div class="f-row two--ColLayout">
        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.register.phonenumber']}}</mat-label>
            <input matInput formControlName="phoneNumber" data-dd-privacy="mask" (keypress)="_CommonService.allowNumberOnly($event)"
              (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
            <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
            <mat-error *ngIf="businessOwnerForm.get('phoneNumber')?.hasError('required')">
              {{content?.dictionary?.['b2b.register.validphonenumber']}}
            </mat-error>
            <mat-error *ngIf=" businessOwnerForm.get('phoneNumber')?.hasError('maxlength') && businessOwnerForm.get('phoneNumber')?.touched "> {{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}} </mat-error>
            <mat-error *ngIf=" businessOwnerForm.get('phoneNumber')?.hasError('minlength') "> {{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}}</mat-error>
            <!-- <mat-error *ngIf="businessOwnerForm.get('phoneNumber')?.hasError('pattern')"> Phone number must be 10 digit. </mat-error> -->
          </mat-form-field>
        </div>

        <div class="f-col">
          <mat-form-field>
            <mat-label>{{content?.['b2b.register.telephone']}}</mat-label>
            <input matInput formControlName="telephone" data-dd-privacy="mask" (keypress)="_CommonService.allowNumberOnly($event)"
              (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" autocomplete="new-password" />
            <mat-icon fontSet="material-symbols-outlined" matSuffix [ngStyle]="{
                color: businessOwnerForm.get('telephone')?.value
                  ? 'green'
                  : 'rgba(0, 0, 0, 0.55)'
              }">phone</mat-icon>
            <mat-error *ngIf="businessOwnerForm.get('telephone')?.hasError('required')">
              {{ content?.['phrases.b2b.register.enterphoneno'] }}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('telephone')?.hasError('maxlength')">
              {{content?.dictionary?.['b2b.register.phonenumbercriteria']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('telephone')?.hasError('minlength')">
              {{content?.dictionary?.['b2b.register.phonenumbercriteria']}}
            </mat-error>
            <mat-error *ngIf="businessOwnerForm.get('telephone')?.hasError('pattern')">
              {{content?.dictionary?.['b2b.register.enterphoneno']}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="f-row">
        <mat-checkbox formControlName="acceptTerms" class="checkbox-wrapper">{{content?.['b2b.register.declaretext']}}
        </mat-checkbox>
      </div>
      <div class="f-row justify-end m-top-8x">
        <button [disabled]="businessOwnerForm.invalid || stateForm.invalid"
          [ngClass]="{ disabled: businessOwnerForm.invalid }" mat-button class="button--secondary-small"
          (click)="OnSave()" type="button">
          {{content?.['b2b.register.save']}}
        </button>
      </div>
    </div>
  </div>
</form>

<div class="form-fill-list" *ngIf="EditLinkOwner">
  <div class="corporatelist">
    <!-- Nationality -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.nationality']}}</div>
      <div class="info-type">
        {{ businessOwnerForm.get("Nationality")?.value?.nationality || "-" }}
      </div>
    </div>

    <!-- Country of Residence -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.countryofresidence']}}</div>
      <div class="info-type">
        {{
        businessOwnerForm.get("countryOfResidence")?.value?.countryName || "-"
        }}
      </div>
    </div>

    <!-- Document Type -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.documenttype']}}</div>
      <div class="info-type">
        {{ selectedDocumentTypeLabel }}
      </div>
    </div>

    <!-- Document Number -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.documentno']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("NationalID")?.value || "-" }}
      </div>
    </div>

    <!-- Document Number -->
    <div class="corp-detail">
      <div class="info-section">{{ content?.['phrases.b2b.register.docexpirydate'] }}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("docExpiry")?.value || "-" }}
      </div>
    </div>

    <!-- Date of Birth -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.dob']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("DOB")?.value || "-" }}
      </div>
    </div>

    <!-- Admin Name -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.adminname']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("title")?.value }}
        {{ businessOwnerForm.get("firstName")?.value }}
        {{ businessOwnerForm.get("lastName")?.value }}
      </div>
    </div>

    <!-- Gender -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.gender'].replace(':','')}}</div>
      <div class="info-type">
        {{ businessOwnerForm.get("gender")?.value || "-" }}
      </div>
    </div>

    <!-- Employee Code -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.employeecode ']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("EmpCode")?.value || "-" }}
      </div>
    </div>

    <!-- Designation -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.designation']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("jobTitle")?.value || "-" }}
      </div>
    </div>

    <!-- Business Email -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.businessemail']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("email")?.value || "-" }}
      </div>
    </div>

    <!-- Country Code -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.countrycode']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ stateForm.get("stateGroup")?.value?.code || "-" }}
      </div>
    </div>

    <!-- Phone Number -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.phonenumber']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("phoneNumber")?.value || "-" }}
      </div>
    </div>

    <!-- Telephone -->
    <div class="corp-detail">
      <div class="info-section">{{content?.['b2b.register.telephone']}}</div>
      <div class="info-type" data-dd-privacy="mask">
        {{ businessOwnerForm.get("telephone")?.value || "-" }}
      </div>
    </div>
  </div>
</div>

<form [formGroup]="businessOwnerForm" (ngSubmit)="onSubmit()" autocomplete="off" [class.d-none]="showbusinessOwnerform">
  <div class="f-col control-wrapper">
    <div class="f-row">
      <div class="f-col">
        <div class="f-row validation-col">
          <label class="mat-label">{{content?.['b2b.register.verifywith']}}</label>
          <mat-radio-group formControlName="verifyWith" aria-label="Select an option" (change)="onRadioChange($event)">
            <mat-radio-button value="Email" [checked]="true"
              selected>{{content?.['b2b.register.email']}}</mat-radio-button>
            <mat-radio-button value="SMS">{{content?.['b2b.register.phone']}}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
  </div>
  <mat-action-row class="contactbox mt-4 mb-20">
    <mat-checkbox formControlName="agreeDataUse" class="checkbox-wrapper mb-4"
      (change)="onCheckboxChange($event)">{{content?.['b2b.register.agreetext']?.replace('Terms of use and Privacy
      Policy.', '')}}
      <a target="_blank" rel="noopener noreferrer"
        href="https://www.saudia.com/en-SA/information/terms-and-conditions/terms-of-use?sc_lang=en&sc_country=SA">Terms
        of use</a>
      and
      <a target="_blank" rel="noopener noreferrer"
        href="https://www.saudia.com/en-IN/information/terms-and-conditions/privacy-policy">Privacy
        {{ content?.['b2b.booking.policy'] }}</a>.
    </mat-checkbox>
  </mat-action-row>
  <div class="internal-footer">
    <div class="container">
      <div class="footer-fare-section">
        <div class="footer-fare"></div>
        <div class="footer-btn">
          <span>
            <button mat-button class="button--primary-large" type="submit" [disabled]="isJoinNowDisabled"
              [class.disabled]="isJoinNowDisabled || commonObj.isSubmitting">
              {{content?.['b2b.register.joinnow']}}
              <ng-container *ngIf="commonObj.isSubmitting; else notSubmittingElse">
                <mat-spinner class="button"></mat-spinner>
              </ng-container>
              <ng-template #notSubmittingElse>
                <mat-icon fontSet="material-symbols-outlined" class="text-white">arrow_forward</mat-icon>
              </ng-template>
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</form>